import React from 'react';
import { LayoutDashboard, PlaneTakeoff, ContactRound, Building2, BookOpenCheck, ReceiptText, FileText, Bell, UsersRound, Settings } from 'lucide-react';
import { ERPUser } from '../core/auth/types';
import { DashboardPage } from '../modules/dashboard/DashboardPage';
import { CrmPage } from '../modules/crm/CrmPage';
import ClientMasterPage from '../modules/clients/ClientMasterPage';
import SupplierMasterPage from '../modules/suppliers/SupplierMasterPage';
import DocumentsPage from '../modules/documents/DocumentsPage';
import NotificationsPage from '../modules/notifications/NotificationsPage';
import BookingsPage from '../modules/bookings/BookingsPage';
import AccountingPage from '../modules/accounting/AccountingPage';
import UsersPage from '../modules/users/UsersPage';
import SettingsPage from '../modules/settings/SettingsPage';
import { PlaceholderPage } from '../modules/placeholder/PlaceholderPage';

export type AppRoute = {
  path: string;
  label: string;
  module: string;
  icon: React.ComponentType<{ size?: string | number }>;
  element: (user: ERPUser) => JSX.Element;
};

export const routes: AppRoute[] = [
  { path: '/', label: 'Dashboard', module: 'dashboard', icon: LayoutDashboard, element: (user) => <DashboardPage user={user} /> },
  { path: '/crm', label: 'CRM / Inquiry', module: 'crm', icon: PlaneTakeoff, element: (user) => <CrmPage user={user} /> },
  { path: '/clients', label: 'Client Master', module: 'clients', icon: ContactRound, element: (user) => <ClientMasterPage user={user} /> },
  { path: '/suppliers', label: 'Supplier Master', module: 'suppliers', icon: Building2, element: (user) => <SupplierMasterPage user={user} /> },
  { path: '/bookings', label: 'Bookings', module: 'bookings', icon: BookOpenCheck, element: (user) => <BookingsPage user={user} /> },
  { path: '/accounting', label: 'Accounting', module: 'accounting', icon: ReceiptText, element: (user) => <AccountingPage user={user} /> },
  { path: '/documents', label: 'Documents', module: 'documents', icon: FileText, element: (user) => <DocumentsPage user={user} /> },
  { path: '/notifications', label: 'Notifications', module: 'notifications', icon: Bell, element: (user) => <NotificationsPage user={user} /> },
  { path: '/users', label: 'Users', module: 'users', icon: UsersRound, element: (user) => <UsersPage user={user} /> },
  { path: '/settings', label: 'Settings', module: 'settings', icon: Settings, element: (user) => <SettingsPage user={user} /> }
];
